import { useEffect } from 'react';
import {  Outlet, useModel, history } from 'umi';
import styles from './index.less';

import Header from '../components/Header';
import Footer from '../components/Footer';

import { ConfigProvider } from 'antd';
import { LoadingOutlined  } from '@ant-design/icons';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

import ruRU from 'antd/locale/ru_RU';

export default function Layout() {
   const { configLoading, getConfig } = useModel('global');

   useEffect(() => {
        getConfig();
    }, []);

    if (configLoading)
        return (<ConfigProvider>
            {antIcon}
        </ConfigProvider>);

  return (
           
                <ConfigProvider>
                    <Header />
                    <div className="content">
                        <Outlet />
                    </div>
                    <Footer />
                </ConfigProvider>
           
  );
}

